import React, { useEffect, useMemo, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction"; // for selectable events
import { Dialog } from "primereact/dialog";
import { formatDateTimeMEL } from "src/helpers/common_helpers";
import { useNavigate } from "react-router";
import { ROUTER } from "src/constants/routes";
import { useDispatch, useSelector } from "react-redux";
import { employeeDropdownForJobLoading, getcustomerdropdownListLoading, getFranchiseAppointmentDetailLoading, getTechnicianDropdownLoading, jobDealerdropdownListLoading } from "src/store/actions";
import { RootReducerState } from "src/store/reducers";
import {  Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { Dropdown } from "primereact/dropdown";
import { Form, Formik } from "formik";
import DropdownInput from "src/components/UI/DropdownInput";
import Button from "src/components/UI/Button";
import FloatInput from "src/components/Common/FloatInput";
import InputCom from "src/components/Common/Input";
import NonScheduledCard from "./NonScheduledCard";
import JobsheetStatusPieChart from "./JobsheetStatus";
import JobTat from "./JobTat";

const EventCalendar = ({convertedDate,date}:any) => {
    const { franchiseAppointmentDetail,eventLoading,franchiseNotScheduledDetail, tatLoading } = useSelector((state: RootReducerState) => state.dashboard);
    const { technicianList,employeeList,customerList,dealerList } = useSelector((state: RootReducerState) => state.jobsheetReducer);
    
    const [startDate,setStartDate] = useState<any>()
    const [endDate,setEndDate] = useState<any>()
    const [value,setValue] = useState<any>()

    const getRandomColorClass = (id: string,className:string) => {
      // const colorClasses = [
      //   "color-1", "color-2", "color-3", "color-4", "color-5",
      //   "color-6", "color-7", "color-8", "color-9", "color-10"
      // ];
      const colorClasses:any = {
        OpenCalls:"color-1",
        ClosedCalls:"color-2",
        Scheduled:"color-3",
        unScheduled:"color-4",
        WithoutAppoinment:"color-5",
        
      };
      return `${colorClasses[id]}${className ? className : ""} height-60`;
    };
    // "👍"
    const ClosedCallTitle = (data: any) => {
      if (data.actualAppoinmentTime) {
        // Always convert both to ISO strings with "Z" (UTC)
        const reached = new Date(data.franchiseReachedTime + "Z");
        const appointment = new Date(data.actualAppoinmentTime);
    
        const reachedTime = Date.UTC(
          reached.getUTCFullYear(),
          reached.getUTCMonth(),
          reached.getUTCDate(),
          reached.getUTCHours(),
          reached.getUTCMinutes()
        );
    
        const appointmentTime = Date.UTC(
          appointment.getUTCFullYear(),
          appointment.getUTCMonth(),
          appointment.getUTCDate(),
          appointment.getUTCHours(),
          appointment.getUTCMinutes()
        );
    
        if (reachedTime === appointmentTime) {
          return "👍⏰"; // Same date/hour/minute
        } else if (reachedTime < appointmentTime) {
          return "👍✅"; // Reached before
        } else {
          return "👍❌"; // Reached after
        }
      } else {
        return "👍";
      }
    };
    
    
    

  const events =useMemo(()=>{
    let data = franchiseAppointmentDetail?.filter((item:any) => item.appoinmentTime)
    .map((item:any,index:any) => ({
      id: item.id.toString() + index.toString(),
      classNames: [getRandomColorClass(item.className,item.appoinmentStatusClass),item.status == "Job Closed" ? "job-closed" : ""],
      title: `${item.className == "ClosedCalls" ? ClosedCallTitle(item) :"" } ${item.jobNumber} - ${item.customerName || item.dealerName || ""} `,
      start: item.appoinmentTime,
      extendedProps: {
        franchiseName: item.franchiseName,
        jobNumber: item.jobNumber,
        dealerName: item.dealerName,
        customerName: item.customerName,
        jobPrefix: item.jobPrefix,
        status: item.status,
        id: item.id,
        technicianId: item.technicianId,
        technicianGUId: item.technicianGUId,
        appoinmentTime: item.appoinmentTime,
        actualAppoinmentTime: item.actualAppoinmentTime,
        franchiseReachedTime: item.franchiseReachedTime,
        franchiseJobClosedTime: item.franchiseJobClosedTime,
      },
    }));
    return data
  },[franchiseAppointmentDetail])

  const tehhnicianDropdownOptions = useMemo(()=>{
    let franchiseData =  technicianList?.length >0 ? technicianList.map((option:any)=>({
      label:option.name,
      value:option?.franchiseId
    })) : []
    return franchiseData
  },[technicianList])

  const customerDropdownOptions = useMemo(()=>{
    return customerList?.length >0 ? customerList.map((option:any)=>({
      label:option.name,
      value:option?.id
    })) : []
  },[customerList])
  
  const dealerDropdownOptions = useMemo(()=>{
    return dealerList?.length >0 ? dealerList.map((option:any)=>({
      label:option.name,
      value:option?.id
    })) : []
  },[dealerList])
  
    useEffect(() => {
      const preloader: any = document.getElementById("preloader");
      if (eventLoading|| tatLoading) {
        preloader.style.display = "block";
      } else {
        preloader.style.display = "none";
      }
    }, [eventLoading,tatLoading]);

    const [visible, setVisible] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState<any>(null);
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(()=>{
      dispatch(getTechnicianDropdownLoading())
      dispatch(employeeDropdownForJobLoading())      
      dispatch(jobDealerdropdownListLoading())  
      dispatch(getcustomerdropdownListLoading())  
    },[])

    const viewJob = (id:any)=>{
        navigate(`${ROUTER.JOB_SHEETS_VIEW}/${id}`)
    }

    const getDataOnChange = (startDateVal:any,endDateVal:any)=>{
      setStartDate(startDateVal)
      setEndDate(endDateVal)
      let modifiedData={
        filters:{
          AppoinmentStartDate:{value:startDateVal},
          AppoinmentEndDate:{value:endDateVal},
          TechnicianId:{value:value?.technicianId ? value?.technicianId : ""},
          CustomerId:{value:value?.customerId ? value?.customerId : ""},
          DealerId:{value:value?.dealerId ? value?.dealerId : ""},
        },
        rows:1000,
      }
      let modifiedNewData={
        filters:{
          TechnicianId:{value:value?.technicianId ? value?.technicianId : ""},
          CustomerId:{value:value?.customerId ? value?.customerId : ""},
          DealerId:{value:value?.dealerId ? value?.dealerId : ""},
        },
        rows:1000,
      }
      dispatch(getFranchiseAppointmentDetailLoading(modifiedData,modifiedNewData))
    }

    const handleSubmit = (values:any) =>{
      setValue(values)
      let modifiedData={
        filters:{
          AppoinmentStartDate:{value:startDate},
          AppoinmentEndDate:{value:endDate},
          TechnicianId:{value:values.technicianId ? values.technicianId : ""},
          CustomerId:{value:values.customerId ? values.customerId : ""},
          DealerId:{value:values.dealerId ? values.dealerId : ""},
          Region:{value:values.Region ? values.Region : ""},
        },
        rows:1000,
      }
      let modifiedNewData={
        filters:{
          TechnicianId:{value:values.technicianId ? values.technicianId : ""},
          CustomerId:{value:values.customerId ? values.customerId : ""},
          DealerId:{value:values.dealerId ? values.dealerId : ""},
          Region:{value:values.Region ? values.Region : ""},
        },
        rows:1000,
      }
      dispatch(getFranchiseAppointmentDetailLoading(modifiedData,modifiedNewData))
    }
    const handleReset = (resetForm:any) =>{
      setValue({})
      resetForm()
      let modifiedData={
        filters:{
          AppoinmentStartDate:{value:startDate},
          AppoinmentEndDate:{value:endDate},
        },
        rows:1000,
      }
      let modifiedNewData={
        filters:{
        },
        rows:1000,
      }
      dispatch(getFranchiseAppointmentDetailLoading(modifiedData,modifiedNewData))
    }

    const initialvalue = {
      technicianId:"",
      customerId:"",
      dealerId:"",
      Region:""
    }
    const calendarRef = useRef<any>(null);

    const getMinutesBetween = (start: string | Date, end: string | Date): number => {
      const startTime = new Date(start).getTime();
      const endTime = new Date(end).getTime();
      const diffInMs = endTime - startTime;
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
      return diffInMinutes;
    };
    
    const convertMinutes = (minutes: any) => {
      let years = Math.floor(minutes / (60 * 24 * 365));
      minutes %= (60 * 24 * 365);
      let months = Math.floor(minutes / (60 * 24 * 30));
      minutes %= (60 * 24 * 30);
      let days = Math.floor(minutes / (60 * 24));
      minutes %= (60 * 24);
      let hours = Math.floor(minutes / 60);
      let remainingMinutes = minutes % 60;
      let output = [];
      if (years > 0) {
        output.push(`${years} year${years > 1 ? 's' : ''}`);
      }
      if (months > 0) {
        output.push(`${months} month${months > 1 ? 's' : ''}`);
      }
      if (days > 0) {
        output.push(`${days} day${days > 1 ? 's' : ''}`);
      }
      if (hours > 0) {
        output.push(`${hours} hour${hours > 1 ? 's' : ''}`);
      }
      if (remainingMinutes > 0) {
        output.push(`${remainingMinutes.toFixed(1)} minute${remainingMinutes > 1 ? 's' : ''}`);
      }
      if (output.length === 0) {
        return "less than a minute";
      } else {
        return (output.join(", "));
      }
    };
    
  return (
    <React.Fragment>
      <Col xl={12}>
        <Card className="card-h-100 event-calendar">
          <CardBody>
            <div className="mb-2">
              <b>Appointment Details</b>
            </div>
            <Col lg={12} className="mt-4 mb-4">
              <Formik
                onSubmit={handleSubmit}
                initialValues={initialvalue}
                enableReinitialize
              >
                {({
                  values,
                  handleChange,
                  touched,
                  errors,
                  handleBlur,
                  resetForm,
                  reset,
                  isSubmitting,
                  ...rest
                }: any) => {
                  return (
                    <Form onChange={handleChange}>
                      <Row>
                        <Col lg={2} md={4} sm={12}>
                          <DropdownInput
                            options={tehhnicianDropdownOptions}
                            name="technicianId"
                            label="Technician"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required={false}
                            value={values.technicianId}
                            invalid={
                              touched["technicianId"] && errors["technicianId"]
                                ? true
                                : false
                            }
                          />
                        </Col>
                        <Col lg={2} md={4} sm={12}>
                          <DropdownInput
                            options={customerDropdownOptions}
                            name="customerId"
                            label="Customer"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required={false}
                            value={values.customerId}
                            invalid={
                              touched["customerId"] && errors["customerId"]
                                ? true
                                : false
                            }
                          />
                        </Col>
                        <Col lg={2} md={4} sm={12}>
                          <DropdownInput
                            options={dealerDropdownOptions}
                            name="dealerId"
                            label="Dealer"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required={false}
                            value={values.dealerId}
                            invalid={
                              touched["dealerId"] && errors["dealerId"]
                                ? true
                                : false
                            }
                          />
                        </Col>
                        <Col lg={2} md={4} sm={12}>
                          <InputCom
                            name="Region"
                            labelName="Region"
                            inputclassName="form-control"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required={false}
                            value={values.Region}
                            disabled={false}
                            invalid={
                              touched["Region"] && errors["Region"]
                                ? true
                                : false
                            }
                          />
                        </Col>
                        <Col
                          lg={2}
                          md={4}
                          sm={12}
                          style={{ display: "flex", alignItems: "end" }}
                        >
                          <div className="d-flex  me-0">
                            <Button
                              className="secondary-btn me-2"
                              label={"Reset"}
                              type="button"
                              onClick={() => handleReset(resetForm)}
                            />
                            <Button
                              className="btn-primary btn-primary-shadow"
                              label={"Search"}
                              type="submit"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
            <div className="" style={{position:"relative"}}>
            {eventLoading &&
            <div className='spinner_position' >
            <div className="lds-spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>}
          <div style={eventLoading ? {filter:"blur(2px)"}:{}}>
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              events={events}
              timeZone="UTC"
              eventDisplay="list-item"
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "timeGridDay,dayGridWeek,dayGridMonth",
              }}
              eventTimeFormat={{
                hour: "numeric",
                minute: "2-digit",
                meridiem: "short",
              }}
              datesSet={(info) => {
                // Fetch events when the view changes
                const startDate = info.startStr;
                const endDate = info.endStr;
                getDataOnChange(startDate, endDate);
              }}
              height="500px"
              contentHeight="auto"
              eventClick={(info: any) => {
                setSelectedEvent(info?.event?.extendedProps); // Store clicked event details
                setVisible(true);
              }}
              // eventMouseEnter={(info:any) => {
              //   setSelectedEvent(info?.event?.extendedProps)
              //   setVisible(true);
              // }}
              dateClick={(info: any) => {
                const calendarApi = calendarRef.current.getApi();
                calendarApi.changeView("timeGridDay", info.dateStr);
              }}
            /> 
            </div>
            </div>
            <div className="d-flex gap-3">
              <div className="legend d-flex gap-2 justify-content-center align-items-center">
                <div
                  className="color-3"
                  style={{ width: "15px", height: "15px" }}
                ></div>
                Scheduled
              </div>
              {/* <div className="legend d-flex gap-2 justify-content-center align-items-center"><div className="color-2" style={{width:"15px",height:"15px"}}></div>Closed</div> */}
              {/* <div className="legend d-flex gap-2 justify-content-center align-items-center"><div className="color-1" style={{width:"15px",height:"15px",animation:"none",backgroundColor:"#ff2f00"}}></div>Open</div> */}
              <div className="legend d-flex gap-2 justify-content-center align-items-center">
                <div
                  className="color-5"
                  style={{
                    width: "15px",
                    height: "15px",
                    animation: "none",
                    backgroundColor: "#861ce2",
                  }}
                ></div>
                Without Appointment
              </div>
               <div className="legend d-flex gap-2 justify-content-center align-items-center">
                <div>⏰</div> Reached On Time
               </div>
               <div className="legend d-flex gap-2 justify-content-center align-items-center">
                <div>✅</div> Reached before time
               </div>
               <div className="legend d-flex gap-2 justify-content-center align-items-center">
                <div>❌</div> Reached late
               </div>
               <div className="legend d-flex gap-2 justify-content-center align-items-center">
                <div>👍</div>Closed Job
               </div>
            </div>
            {/* <Row>
              <Col lg={4} md={4} sm={12}>
                <Card>
                  <CardHeader>
                    <b>Non Scheduled Technician</b>
                  </CardHeader>
                  <CardBody style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <Row>
                      <Col lg={12}>
                        <div className="d-flex gap-4">
                          <div className="data-non-scheduled-header-index">
                            <div className="label">S.No</div>
                          </div>
                          <div className="data-non-scheduled-header">
                            <div className="label">Technician</div>
                          </div>
                          <div className="data-non-scheduled-header">
                            <div className="label">Job Number</div>
                          </div>
                          <div className="data-non-scheduled-header">
                            <div className="label">Assigned Time</div>
                          </div>
                        </div>
                      </Col>
                      {franchiseNotScheduledDetail?.map(
                        (data: any, index: any) => {
                          return (
                            <NonScheduledCard
                              data={data}
                              index={index}
                              key={index}
                            />
                          );
                        }
                      )}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={8} md={8} sm={12}>
                <JobsheetStatusPieChart date={convertedDate} realDate={date} />
              </Col>
            </Row> */}
            <Dialog
              visible={visible}
              onHide={() => setVisible(false)}
              header="Appointment Details"
              className="calendar-dialog"
            >
              {selectedEvent && (
                <div className="appointment-calendar">
                  <div className="header">
                    <div className="job-status">{selectedEvent.status}</div>
                    <div
                      className="job-view"
                      onClick={() => viewJob(selectedEvent.id)}
                    >
                      View Job
                    </div>
                  </div>
                  <div className="model-content">
                    {selectedEvent.jobNumber && (
                      <div className="data-content">
                        <div className="label">Job Number</div>
                        <div
                          className="data-value"
                          style={{ cursor: "pointer", color: "blue" }}
                          onClick={() => viewJob(selectedEvent.id)}
                        >
                          {selectedEvent.jobNumber}
                        </div>
                      </div>
                    )}
                    {selectedEvent.franchiseName && (
                      <div className="data-content">
                        <div className="label">Technician</div>
                        <div className="data-value">
                          {selectedEvent.franchiseName}
                        </div>
                      </div>
                    )}
                    {selectedEvent.dealerName && (
                      <div className="data-content">
                        <div className="label">Dealer</div>
                        <div className="data-value">
                          {selectedEvent.dealerName}
                        </div>
                      </div>
                    )}
                    {selectedEvent.customerName && (
                      <div className="data-content">
                        <div className="label">Customer</div>
                        <div className="data-value">
                          {selectedEvent.customerName}
                        </div>
                      </div>
                    )}
                    {(selectedEvent.appoinmentTime ||
                      selectedEvent?.actualAppoinmentTime) && (
                      <div className="data-content">
                        <div className="label">Appointment Time</div>
                        <div className="data-value">
                          {formatDateTimeMEL(
                            selectedEvent?.actualAppoinmentTime
                              ? selectedEvent?.actualAppoinmentTime
                              : selectedEvent.appoinmentTime
                          )}
                        </div>
                      </div>
                    )}
                    {selectedEvent?.franchiseReachedTime && (
                      <div className="data-content">
                        <div className="label">Start Time</div>
                        <div className="data-value">
                          {formatDateTimeMEL(
                            selectedEvent.franchiseReachedTime
                          )}
                        </div>
                      </div>
                    )}
                    {selectedEvent?.franchiseJobClosedTime && (
                      <div className="data-content">
                        <div className="label">End Time</div>
                        <div className="data-value">
                          {formatDateTimeMEL(
                            selectedEvent.franchiseJobClosedTime
                          )}
                        </div>
                      </div>
                    )}
                    {selectedEvent?.franchiseReachedTime && selectedEvent?.franchiseJobClosedTime && (
                        <div className="data-content">
                          <div className="label">Consumption Time</div>
                          <div className="data-value">
                            {convertMinutes(getMinutesBetween( selectedEvent.franchiseReachedTime, selectedEvent.franchiseJobClosedTime ))}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              )}
            </Dialog>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default EventCalendar;
